import { ProfileIcon } from "../resources/Icons"

const Avatar = () => {
    return (
        <div>
            { ProfileIcon }
        </div>
    )
}
export default Avatar